/**
 * Meta (Facebook) Pixel event helpers.
 * fbq is initialized in public/index.html.
 * Safe to call even if fbq isn't loaded yet — checks for window.fbq.
 */

const safeTrack = (event, payload) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', event, payload);
    }
  } catch (err) {
    // Analytics must never break the app. Log so we can spot real issues
    // in production without throwing.
    if (typeof console !== 'undefined') {
      console.warn('Meta Pixel track failed:', event, err);
    }
  }
};

export const trackPageView = () => safeTrack('PageView');

export const trackViewContent = (product) => {
  if (!product) return;
  safeTrack('ViewContent', {
    content_ids: [product.id],
    content_name: product.name,
    content_type: 'product',
    value: product.price,
    currency: 'DZD',
  });
};

export const trackAddToCart = (product, quantity = 1) => {
  if (!product) return;
  safeTrack('AddToCart', {
    content_ids: [product.id],
    content_name: product.name,
    content_type: 'product',
    value: product.price * quantity,
    currency: 'DZD',
    contents: [{ id: product.id, quantity, item_price: product.price }],
  });
};

export const trackInitiateCheckout = (items, total) => {
  if (!items?.length) return;
  safeTrack('InitiateCheckout', {
    content_ids: items.map((i) => i.id),
    contents: items.map((i) => ({ id: i.id, quantity: i.quantity, item_price: i.price })),
    num_items: items.reduce((n, i) => n + i.quantity, 0),
    value: total,
    currency: 'DZD',
  });
};

export const trackPurchase = (order) => {
  if (!order) return;
  safeTrack('Purchase', {
    content_ids: (order.items || []).map((i) => i.product_id),
    contents: (order.items || []).map((i) => ({
      id: i.product_id,
      quantity: i.quantity,
      item_price: i.price,
    })),
    num_items: (order.items || []).reduce((n, i) => n + i.quantity, 0),
    value: order.total,
    currency: 'DZD',
  });
};

export const trackLead = () => safeTrack('Lead');
